import { useQuery } from "@apollo/client"
import { GET_MY_USER } from "../graphql/queries/getMyUser"

export type MyUserQuery = {
  myUser: {
    id: number | string
    organizationRole: {
      id: number | string
      name: string
    }
  }
}

export const useMyUser = () => {
  const { data, error, loading, refetch } = useQuery<MyUserQuery>(GET_MY_USER, {})
  return { user: data?.myUser, error, loading, refetch }
}
